import { useMapped } from "@omni/utils/context/mapped.context";
import { ReactNode } from "react";

import { SlideContextProvider } from "@/components/Product/ProductSlider/components/slider/components/slides/components/slide/context/slide.context";
import { useProductSliderSourceContext } from "@/components/Product/ProductSlider/context/productSliderSource.context";

type Props = {
    children: ReactNode;
};

export const Base = ({ children }: Props) => {
    const { products } = useProductSliderSourceContext();
    const { index } = useMapped();

    const product = products[index];

    return (
        <SlideContextProvider product={product}>
            {children}
        </SlideContextProvider>
    );
};
